import {Pipe, PipeTransform} from '@angular/core';
import {ComponentWithConfigsObject} from '../../../../configuration/componentsWithConfigs.datamodel';
import {ConfigurationFn, ConfigurationObject} from '../../../../configuration/store/configuration.datamodel';
import {ActorType} from '../../../datamodel';
import {PermissionsService} from "../../../../user/permissions/permissions.service";
import {PermissionsType} from "../../../../user/permissions/permissions.datamodel";
import {LSSEntityObject} from '../../lssEntity.datamodel';

@Pipe({
    name: 'isConfigEditable',
    standalone: false
})
export class IsConfigEditablePipe implements PipeTransform {
  constructor(private readonly permissionsService: PermissionsService) {
  }

  transform(component: ComponentWithConfigsObject, configId: string, entity: LSSEntityObject, officeId: string): boolean {
    const config = component.configurations.find(config => config.guid === configId);
    const isGlobal = config?.actor?.actorType === ActorType.PRODUCT;
    if (isGlobal && !this.permissionsService.isUserAuthorized(PermissionsType.MANAGE_GLOBAL_CONFIGURATION)) {
      return false;
    }

    return !ConfigurationFn.isDefaultConfig(config) &&
      (this.permissionsService.isUserAuthorized(PermissionsType.MANAGE_MARKET_CATALOG, entity.label) ||
        this.canEditAtOfficeLevel(config, officeId));
  }

  private canEditAtOfficeLevel(config: ConfigurationObject | undefined, officeId: string) {
    return config?.actor?.actorType === ActorType.OFFICE && this.permissionsService
    .isUserAuthorized(PermissionsType.MANAGE_SCRIPT_CONFIGURATION, officeId);
  }
}
